import React from "react";

// Delete Account component
const DeleteAccount: React.FC = () => {
  return (
    <>
      <h1>Delete Account</h1>
      <h2>Delete Account</h2>
    </>
  );
};

export default DeleteAccount;
